<template>
  <div class="modal fade" id="mod-account-posting-filter" role="dialog">
    <div
      class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
    >
      <div
        class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
      >
        <div class="modal-header- flex items-start justify-between p-0 m-0">
          <h4
            class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
          >
            Filter posting
          </h4>
          <button
            class="text-2xl text-[#353535] outline-none focus:outline-none"
            type="button"
            data-dismiss="modal"
            aria-hidden="true"
            @click="clearFilter"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div class="m-0 p-0">
          <div class="pb-[24px]">
            <label class="text=[#353535] font-medium text-[14px] leading-[20px]"
              >Customer</label
            >
            <div>
              <multiselect
                v-model="accountPostingFilter.customerIdSelect"
                label="text"
                track-by="id"
                :options="customers"
                @select="setCustomer"
              ></multiselect>
            </div>
          </div>
          <div class="pb-[24px]">
            <label
              class="text=[#353535] font-medium text-[14px] leading-[20px]"
            >
              Account ID</label
            >
            <div>
              <input
                @input="setAccount"
                :value="accountPostingFilter.accountId"
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                type="text"
                placeholder="Enter Account Id"
              />
            </div>
          </div>
          <div class="pb-[24px]">
            <label class="text=[#353535] font-medium text-[14px] leading-[20px]"
              >Authorized By</label
            >
            <div>
              <select
                @input="setAuthorizeBy"
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                placeholder="Select a customer"
                :value="accountPostingFilter.authorizedBy"
              >
                <option value="">Select an option</option>
                <option
                  v-for="c in distributors.filter(
                    (distributor) => distributor.text !== null
                  )"
                  :key="c.id"
                  :value="c.id"
                >
                  {{ c.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="pb-[24px]">
            <label class="text=[#353535] font-medium text-[14px] leading-[20px]"
              >Start Date</label
            >
            <div>
              <input
                :class="[{ 'is-invalid': v1.starts }]"
                type="date"
                :max="maxDate"
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                placeholder="Select a date"
                v-model="accountPostingFilter.startDate"
              />
            </div>
          </div>
          <div class="pb-[24px]">
            <label class="text=[#353535] font-medium text-[14px] leading-[20px]"
              >End Date</label
            >
            <div>
              <input
                :class="[{ 'is-invalid': v1.starts }]"
                type="date"
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                :max="maxDate"
                placeholder="Select a date"
                v-model="accountPostingFilter.endDate"
              />
            </div>
          </div>
        </div>
        <div class="flex items-center gap-[8px] w-full mt-[24px]">
          <button
            class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
            @click="clearFilter"
            type="button"
          >
            Clear
          </button>
          <button
            class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
            type="button"
            data-dismiss="modal"
          >
            Cancel
          </button>
          <button
            :disabled="accountPosting.loading"
            class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
            data-dismiss="modal"
            @click.prevent="filter"
            type="button"
          >
            <span
              v-if="accountPosting.loading"
              class="spinner-border spinner-border-sm"
              role="status"
            >
              <i class="sr-only">Loading...</i>
            </span>
            <span v-else> Submit </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import datePicker from "vue-bootstrap-datetimepicker";
import Multiselect from "vue-multiselect";
import { helper } from "@/helper";
export default {
  components: { datePicker, Multiselect },
  data() {
    return {
      paymentChannels: [],
      customers: [],
      distributors: [],
      v1: {
        name: false,
        type: false,
        frequency: false,
        starts: false,
        ends: false,
      },

      options: {
        format: "YYYY-MM-DD",
      },

      endOptions: {
        format: "YYYY-MM-DD",
      },

      paymentItem: [
        {
          name: "Payment",
          value: 0,
        },
        {
          name: "Credit Note",
          value: 1,
        },
        {
          name: "Debit Note",
          value: 2,
        },
      ],
      maxDate: "",
    };
  },

  computed: {
    ...mapGetters(["accountPostingFilter", "accountPosting"]),
    user: function() {
      return this.$store.state.currentUser;
    },
  },

  mounted() {
    this.maxDate = helper.preventFutureDateSelection();
  },

  created() {
    this.getCustomers();
    this.getPaymentChannels();
    this.getDistributors();
  },

  methods: {
    formatPickerDate() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      // 15th two months prior
      const minDate = new Date(today);
      minDate.setMonth(minDate.getMonth() - 2);
      minDate.setDate(15);
      // 15th in two months
      const newDate = new Date(today);
      return newDate.setMonth(newDate.getMonth());
    },
    ...mapActions(["getAccountPostings"]),

    setCustomer(value) {
      this.accountPostingFilter.customerIdSelect = value;
      this.accountPostingFilter.customerId = value.id;
      this.updateFilter(this.accountPostingFilter);
    },

    setAccount(value) {
      this.accountPostingFilter.accountId = value.target.value;
      this.updateFilter(this.accountPostingFilter);
    },

    setPaymentChannel(value) {
      this.accountPostingFilter.paymentChannelId = value.target.value;
      this.updateFilter(this.accountPostingFilter);
    },

    setStartDate(date) {
      this.accountPostingFilter.startDate = date;
      this.updateFilter(this.accountPostingFilter);
    },

    setEndDate(date) {
      this.accountPostingFilter.endDate = date;
      this.updateFilter(this.accountPostingFilter);
    },

    setCreatedBy(value) {
      this.accountPostingFilter.createdBy = value.target.value;
      this.updateFilter(this.accountPostingFilter);
    },

    setAuthorizeBy(value) {
      this.accountPostingFilter.authorizedBy = value.target.value;
      this.updateFilter(this.accountPostingFilter);
    },

    async getCustomers() {
      try {
        const response = await this.$http.get(
          "/Users/getItemListOfCustomers/" + this.user.parentId
        );

        if (response.ok) {
          this.customers = response.body;
        }
      } catch (error) {}
    },

    async getPaymentChannels() {
      try {
        const response = await this.$http.get(
          "/PaymentChannels/getListNoPaging?active=true" +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "")
        );

        if (response.ok) this.paymentChannels = response.body;
      } catch (error) {}
    },

    clearFilter() {
      this.$store.commit("clearAccountPostingFilter");
      this.updateFilter(this.accountPostingFilter);
      this.$emit("onFilterClear");
    },

    setDateTime() {
      const format = "YYYY-MM-DD";
      const date = new Date();
      this.accountPostingFilter.startDate = moment(
        new Date(date.getFullYear(), date.getMonth(), 1)
      ).format(format);

      this.accountPostingFilter.endDate = moment(Date.now()).format(format);
      this.updateFilter(this.accountPostingFilter);
    },

    updateFilter(filter) {
      this.$store.commit("updatePostingFilter", filter);
    },

    prepareDetail(value) {
      const name = value.paymentChannelTypeName;
      let result = "";
      if (name) {
        result += name;

        if (name.toLowerCase() === "bank") {
          result += "/ " + value.bankName + "/ " + value.accountNumber;
        } else if (name.toLowerCase() === "pos") {
          result += "/ " + value.bankName + "/ " + value.terminalId;
        } else if (name.toLowerCase() === "cryptocurrency") {
          result += "/ " + value.bankName + "/ " + value.walletAddress;
        }
      }
      return result;
    },

    filter() {
      this.$store.dispatch("getAccountPostings");
    },

    async getDistributors() {
      this.isBusy = true;

      try {
        const response = await this.$http.get("/Users/getParentDistributors");
        if (response.ok) {
          this.distributors = response.body;
        }
      } catch (error) {}
      this.isBusy = false;
    },
  },
};
</script>
